<template>
  <div class="calendar-table">
    <div class="calendar-table__head">
      <div>{{ $t('monday') }}</div>
      <div>{{ $t('tuesday') }}</div>
      <div>{{ $t('wednesday') }}</div>
      <div>{{ $t('thursday') }}</div>
      <div>{{ $t('friday') }}</div>
      <div>{{ $t('saturday') }}</div>
      <div>{{ $t('sunday') }}</div>
    </div>
    <div class="calendar-table__body">
      <div v-for="j in startOffset" :key="j"></div>
      <CalendarTableCell v-for="date in monthDays" :key="date"
                         :date="parseInt(date.split('-')[2])"
                         :transactions-data="!!calendarData[date] ? calendarData[date] : null"
                         :active="dateSelected === date"
                         @click="$emit('selectDate',date)"/>
    </div>
  </div>
</template>

<script>
import CalendarTableCell from "@/components/cabinet/Money/Calendar/CalendarTable/CalendarTableCell";
import {mapState} from "vuex";

export default {
  name: "CalendarTable",
  components: {CalendarTableCell},
  props: {
    date: {
      type: String
    },
    dateSelected: {
      type: [String, Number]
    }
  },
  computed: {
    ...mapState('space/calendar', ['calendarData']),
    year() {
      return this.date.split('-')[0]
    },
    month() {
      return this.date.split('-')[1]
    },
    monthDays() {
      return this.getDaysInMonth(this.month, this.year)
    },
    startOffset() {
      const offset = new Date(`${this.year}-${parseInt(this.month)}-01`).getDay();
      return offset === 0 ? 6 : offset - 1;
    }
  },
  methods: {
    getDaysInMonth(month, year) {
      let date = new Date(`${year}-${parseInt(month)}-01`);
      let days = [];
      while (date.getMonth() + 1 === parseInt(month)) {
        days.push(this.$moment(date).format('YYYY-MM-DD'));
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
  },
  i18n: {
    messages: {
      en: {
        sunday: 'Sun',
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
      },
      ru: {
        monday: 'Пн',
        tuesday: 'Вт',
        wednesday: 'Ср',
        thursday: 'Чт',
        friday: 'Пт',
        saturday: 'Сб',
        sunday: 'Вс',
      }
    }
  }
}
</script>

<style lang="scss">
.calendar-table {
  &__head {
    @apply grid grid-cols-7;
    > div {
      @apply text-text-ternary text-md text-center py-4 font-bold;
    }
  }

  &__body {
    @apply grid grid-cols-7;
    > div {
      @apply border-t border-line;
    }
  }
}

</style>